import {LOCALE_ID, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser'
import {RouteReuseStrategy} from '@angular/router';

import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {SplashScreen} from '@ionic-native/splash-screen/ngx';
import {StatusBar} from '@ionic-native/status-bar/ngx';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HttpClientModule} from '@angular/common/http';
import {IonicStorageModule} from '@ionic/storage';
import {HTTP} from '@ionic-native/http/ngx';
import {FileOpener} from '@ionic-native/file-opener/ngx';
import {File} from '@ionic-native/file/ngx';
import {Network} from '@ionic-native/network/ngx';




@NgModule({
    declarations: [AppComponent],
    entryComponents: [],
    imports: [
        BrowserModule,
        IonicModule.forRoot({
            backButtonText: 'Voltar',
            rippleEffect: false,
        }),
        IonicStorageModule.forRoot(),
        HttpClientModule,
        AppRoutingModule
    ],
    providers: [
        StatusBar,
        SplashScreen,
        HTTP,
        File,
        FileOpener,
        Network,
        {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
        {
            provide: LOCALE_ID,
            useValue: 'pt'
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
